const normalizedSiteUrl = (
  process.env.REACT_APP_SITE_URL || "https://www.omniminds.org"
).replace(/\/$/, "");

const publicUrl = process.env.PUBLIC_URL || "";

export const siteUrl = normalizedSiteUrl;
export const siteName = "OmniMinds";
export const companyName = "OmniMinds LLC";
export const contactEmail = "contact@omniminds.org";
export const themeColor = "#06151A";

export const pageUrls = {
  home: `${siteUrl}/`,
  translateApp: `${siteUrl}/translateapp`,
  privacy: `${siteUrl}/privacy`,
  terms: `${siteUrl}/terms`,
};

export const brandIconPath = `${publicUrl}/brand/omniminds-icon.svg`;
export const brandIconUrl = `${siteUrl}/brand/omniminds-icon-512.png`;
export const socialImageUrl = `${siteUrl}/brand/social-preview.png`;
export const socialImageAlt =
  "OmniMinds abstract brand visual for AI consulting, scientific software, and app development.";
export const heroImagePath = `${publicUrl}/brand/omniminds-innovation-hero.png`;
export const translateHeroPath = `${publicUrl}/brand/translate-app-hero.png`;
export const chatCultureIconUrl = `${siteUrl}/brand/chatculture-icon.png`;
export const translateAppIconUrl = `${siteUrl}/brand/translate-text-voice-icon.png`;

export const chatCultureUrl = "https://chatculture.app";
export const chatCultureAppStoreUrl =
  "https://apps.apple.com/us/app/chatculture-chat-translate/id6446968637";
export const translateAppStoreUrl =
  "https://apps.apple.com/us/app/translate-text-voice/id6499226092";
export const translatePlayStoreUrl =
  "https://play.google.com/store/apps/details?id=com.omniminds.translatetextandvoice";

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${siteUrl}/#organization`,
  name: siteName,
  legalName: companyName,
  url: siteUrl,
  logo: brandIconUrl,
  email: contactEmail,
  description:
    "Scientific consulting, AI product engineering, mobile app development, and applied innovation studio.",
  contactPoint: [
    {
      "@type": "ContactPoint",
      email: contactEmail,
      contactType: "customer support",
      availableLanguage: "English",
    },
  ],
  knowsAbout: [
    "AI consulting",
    "Scientific software",
    "Mobile app development",
    "Applied AI",
    "Product engineering",
    "Language technology",
  ],
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${siteUrl}/#website`,
  name: siteName,
  url: siteUrl,
  inLanguage: "en-US",
  publisher: {
    "@id": `${siteUrl}/#organization`,
  },
};

export const publisherSchema = {
  "@type": "Organization",
  "@id": `${siteUrl}/#organization`,
  name: siteName,
  url: siteUrl,
  logo: brandIconUrl,
};

export function buildWebPageSchema({ url, name, description, image = socialImageUrl, imageAlt }) {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${url}#webpage`,
    url,
    name,
    description,
    inLanguage: "en-US",
    isPartOf: {
      "@id": `${siteUrl}/#website`,
    },
    publisher: {
      "@id": `${siteUrl}/#organization`,
    },
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: image,
      width: 1672,
      height: 941,
      caption: imageAlt || socialImageAlt,
    },
  };
}

export function buildBreadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}
